import store from "@/store";
import router from "@/router";
import { setToken } from "@/api/services/http.service";

let refresh = true;

export default () => {
  if (refresh) {
    refresh = false;
    store
      .dispatch("auth/REFRESH_TOKEN")
      .then(() => {
        refresh = true;
        // router.push({ name: 'dashboard' })
        // document.location.reload(false)
      })
      .catch(() => {
        refresh = true;
        store.commit("auth/SET_TOKEN", null);
        localStorage.removeItem("token");
        setToken(undefined);
        router.push({ name: "login" });
      });
  }
};
